import axios from 'axios'

// Backend base URL. Defaults to the local dev backend; set VITE_API_BASE_URL
// at build time (see .env.example) to point the built site at the deployed
// API, e.g. VITE_API_BASE_URL=https://api.intraveo.com
const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'http://127.0.0.1:8000'

const apiClient = axios.create({
  baseURL,
})

export default apiClient
